<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import AOS from 'aos'

  export default {
    name: 'App',
    created() {
      AOS.init()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue